import { lazy } from 'react'

import type { RouteObject } from 'react-router'

import { DetalhesEmpreendimentoPageSuspense } from '@/features/empreendimentos/brasil/pages/detalhes-empreendimento/suspense'
import { EmpreendimentoMidiasPageSuspense } from '@/features/empreendimentos/shared/components/empreendimento-midias.suspense'

const EmpreendimentosPage = lazy(() =>
  import('@/features/empreendimentos/brasil/pages/empreendimentos').then((module) => ({
    default: module.EmpreendimentosPage,
  })),
)

const DetalhesEmpreendimentoPage = lazy(() =>
  import('@/features/empreendimentos/brasil/pages/detalhes-empreendimento').then((module) => ({
    default: module.DetalhesEmpreendimentoPage,
  })),
)

const EmpreendimentoMidiasPage = lazy(() =>
  import('@/features/empreendimentos/brasil/pages/empreendimento-midias').then((module) => ({
    default: module.EmpreendimentoMidiasPage,
  })),
)

export const brasilEmpreendimentosRoutes: RouteObject[] = [
  {
    path: 'empreendimentos',
    children: [
      {
        index: true,
        element: <EmpreendimentosPage />,
      },
      {
        path: ':idExterno',
        element: (
          <DetalhesEmpreendimentoPageSuspense>
            <DetalhesEmpreendimentoPage />
          </DetalhesEmpreendimentoPageSuspense>
        ),
      },
      {
        path: ':idExterno/:midiaSelecionada',
        element: (
          <EmpreendimentoMidiasPageSuspense>
            <EmpreendimentoMidiasPage />
          </EmpreendimentoMidiasPageSuspense>
        ),
      },
    ],
  },
]
